
module.exports = {
	status: 'ready',
	title: 'Search',
	notes: '',
	context: {
		placeholder: 'Sök',
		search: 'Sök'
	}
};
